<template>
  <v-data-iterator :items="organizations" row wrap>
    <template v-slot:default="{ items }">
      <v-row>
        <v-col v-for="item in items" :key="item.id" cols="12" sm="6" md="4" lg="3">
          <organization-card :organization="item" :show="viewItem" />
        </v-col>
      </v-row>
    </template>
  </v-data-iterator>
</template>

<script>
import organizationPerimeter from '../perimeters'
import OrganizationCard from './OrganizationCard'

export default {
  name: 'OrganizationList',
  components: { OrganizationCard },
  props: {
    organizations: Array,
    viewItem: Function,
    editItem: Function
  },
  perimeters: [organizationPerimeter],
  data: () => ({})
}
</script>
